import { useSWRConfig } from 'swr'
import { TOTAL_ITEMS_KEY } from '../../constants/constants'
import { FindTotalItemsByUserDocument } from '../../services/queries/find-total-items-by-user.generated'
import { cartTotalItemsCache } from '../../utils/cache/cartTotalItemsCache'

/**
 * Updates the number of items in the cart
 */
export const useUpdateTotalItems = () => {
	const { mutate } = useSWRConfig()

	const updateTotalItems = async (totalItems: number) => {
		await cartTotalItemsCache().addKeyToCache(TOTAL_ITEMS_KEY, totalItems)
		await mutate(
			[FindTotalItemsByUserDocument],
			{ findTotalItemsByUser: { totalItems } },
			{ revalidate: false }
		)
	}

	return { updateTotalItems }
}
